export default {
  setPoi(state, payload) {
    let { poiType, data } = payload;
    return (state.pois[poiType] = data);
  },
  setPois(state, payload) {
    return (state.pois = payload);
  },
};
